export default "__VITE_ASSET__BM0$a$e9__"